import ArrowPopper from "components/app/ArrowPopper";
import MButton from "components/momentum/MButton";
import { FC } from "react";

interface DeleteConfirmPopProps {
  anchor: HTMLButtonElement | HTMLDivElement | null;
  label: string;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteConfirmPop: FC<DeleteConfirmPopProps> = ({ anchor, label, onClose, onDelete }) => {
  return (
    <ArrowPopper
      open={Boolean(anchor)}
      anchorEl={anchor}
      placement="bottom"
      handleClose={() => onClose()}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <p
          style={{
            justifySelf: "center",
            fontSize: "1rem",
            fontWeight: 600,
          }}
        >
          Confirmation
        </p>
        <p>{label}</p>
        <div style={{ alignSelf: "flex-end", marginTop: 8 }}>
          <MButton
            buttonType="blue-reverse"
            buttonSize={28}
            onClick={() => onClose()}
          >
            Cancel
          </MButton>
          <MButton
            buttonType="blue"
            buttonSize={28}
            onClick={onDelete}
          >
            Submit
          </MButton>
        </div>
      </div>
    </ArrowPopper>
  );
};

export default DeleteConfirmPop;
